<template>
  <div class="page event-management">
    <management-nav></management-nav>
    <side-menu activeNav="Event" childName="Agenda"></side-menu>

    <div class="content">
      <div class="dashboard">
        <heading :title="'Agenda'"></heading>

        <button @click="openPopup()" class="btn">
          <img class="white_icon" src="@/assets/img/plus.svg" />Add Agenda
        </button>

        <div class="agendas">
          <div class="agenda">
            <!-- <div class="date">
              <p>Monday, May 25, 2020</p>
            </div>-->

            <table>
              <thead>
                <td>Title</td>
                <td>Starting Date</td>
                <td>Start Time</td>
                <td>End Time</td>
                <td>Venue/Area</td>
                <td>Panelists</td>
                <td>Description</td>
                <td>Tags</td>
                <td>Action</td>
              </thead>

              <tbody>
                <tr v-for="session in sessions" :key="session.id">
                  <td class="company" data-label="Title">
                    {{ session.title }}
                  </td>
                  <td class="company" data-label="Start Date">
                    {{ session.start_date | format_date }}
                  </td>
                  <td class="company" data-label="Start Time">
                    {{ session.start_time | format_time }}
                  </td>
                  <td class="company" data-label="End Time">
                    {{ session.end_time | format_time }}
                  </td>
                  <td class="company" data-label="Start Time">
                    {{ session.venue_name }} / {{ session.area }}
                  </td>
                  <td class="company" data-label="Panelists">
                    <div v-if="Object.keys(speakers_obj).length">
                      <div v-for="s in session.panelists" :key="s">
                        <p>{{ s.display_name }},</p>
                      </div>
                    </div>
                  </td>
                  <td class="description" data-label="Description">
                    <p>{{ session.description }}</p>
                  </td>
                  <td class="Tags" data-label="Tags">
                    <p>{{ session.tags.join() }}</p>
                  </td>
                  <td data-label="Action">
                    <div class="settings">
                      <img
                        @click="deleteAgenda(session.id)"
                        src="@/assets/img/trash.svg"
                      />
                      <img
                        @click="editAgenda(session)"
                        src="@/assets/img/settings.svg"
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- <div class="card" v-for="session in sessions" :key="session.id">
              <p class="title">Title: {{ session.title }}</p>
              <p class="company">Start Time: {{ session.start_time | format_date_time }}</p>
              <p class="company">End Time: {{ session.end_time | format_date_time }}</p>
              <p class="description">
                Panelists:
                {{ formatArray(session, "panelists", "display_name") }}
              </p>
              <p class="description">Description: {{ session.description }}</p>
              <div class="controls">
                <img @click="deleteAgenda(session.id)" src="@/assets/img/trash.svg" />
                <img @click="editAgenda(session)" src="@/assets/img/settings.svg" />
              </div>
            </div> -->
            <popup title="Add An Agenda" :show="showPopup">
              <div class="input">
                <p>
                  Event Start Date: {{ event.start_time | format_date_time }}
                </p>
                <p>
                  Event End Date:
                  {{ event.end_time | format_date_time }}
                </p>
              </div>
              <div class="inputs">
                <div class="datetime">
                  <div class="input">
                    <check v-model="session.hide_on_agenda" :value="true"
                      >Show in Agenda.</check
                    >
                  </div>
                  <div class="input">
                    <check v-model="session.is_session" :value="true"
                      >Show in Sessions</check
                    >
                  </div>
                  <div class="input">
                    <label
                      >Select a Venue

                      <span class="required">*</span>
                    </label>
                    <v-select
                      label="name"
                      v-model="selectedVenue"
                      :options="venues"
                    >
                    </v-select>

                    <div v-if="selectedVenue">
                      <label
                        >Select an Area <span class="required">*</span>
                      </label>
                      <v-select
                        label="name"
                        v-model="selectedArea"
                        :options="selectedVenue.areas"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div v-if="selectedVenue">
                    <div class="input">
                      <label
                        >Selected Date

                        <span class="required">*</span>
                      </label>
                      <v-select
                        label="label"
                        :reduce="(d) => d.timestamp"
                        v-model="start_date"
                        :options="eventDates"
                      >
                      </v-select>
                      <!-- <input
                      @click="$refs.start_date.isOpen = true"
                      type="text"
                      readonly
                      :value="start_date"
                    />
                    <datetime
                      hidden
                      ref="start_date"
                      type="datetime"
                      v-model="session.start_date"
                    ></datetime> -->
                    </div>
                    <br />
                    <div class="input">
                      <label
                        >Start Time

                        <span class="required">*</span>
                      </label>
                      <input
                        @click="$refs.start_time.isOpen = true"
                        type="text"
                        readonly
                        :value="start_time"
                      />
                      <datetime
                        hidden
                        ref="start_time"
                        type="time"
                        use12-hour
                        v-model="session.start_time"
                      ></datetime>
                    </div>
                    <br />
                    <div class="input">
                      <label
                        >End Time
                        <span class="required">*</span>
                      </label>
                      <input
                        @click="$refs.end_time.isOpen = true"
                        type="text"
                        readonly
                        :value="end_time"
                      />
                      <datetime
                        hidden
                        ref="end_time"
                        type="time"
                        use12-hour
                        v-model="session.end_time"
                      ></datetime>
                    </div>
                    <div class="agenda_inputs">
                      <div class="input">
                        <label
                          >Title
                          <span class="required">*</span>
                        </label>
                        <input v-model="session.title" type="text" />
                      </div>
                      <div class="input">
                        <label> Tags </label>
                        <input ref="tags" type="text" @change="addTags" />
                        <div>
                          <ul>
                            <li v-for="(tag, i) in session.tags" :key="i">
                              {{ tag }}
                              <span
                                ><img
                                  @click="removeTag(i)"
                                  style="width: 30px"
                                  src="@/assets/img/trash.svg"
                              /></span>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div class="input">
                        <label
                          >Description
                          <span class="required">*</span>
                        </label>
                        <textarea
                          v-model="session.description"
                          draggable="no"
                        ></textarea>
                      </div>

                      <div class="input">
                        <label
                          >Speakers
                          <span class="required">*</span>
                        </label>
                        <v-select
                          multiple
                          :options="speakers"
                          label="display_name"
                          v-model="selectedPanelists"
                          :reduce="(s) => s.id"
                          :selectable="
                            (speaker) => !selectedPanelists.includes(speaker.id)
                          "
                        ></v-select>
                        <a
                          :href="`/event/${$route.params.id}/speakers`"
                          v-if="!speakers.length"
                          >Add A Speaker</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="btns">
                <button @click="closePopup" class="btn text_btn">Cancel</button>
                <button @click="validation" class="btn">Save</button>
              </div>
            </popup>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import BtnNav from "@/components/BtnNav.vue";
import managementBar from "@/components/managementBar.vue";
import managementMenu from "@/components/managementMenu.vue";
import Popup from "@/components/Popup.vue";
import Title from "@/components/Title.vue";
import { Datetime } from "vue-datetime";
import PrettyCheck from "pretty-checkbox-vue/check";
import Swal from "sweetalert2";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;
var moment = require("moment");

export default {
  name: "events",
  components: {
    "btn-nav": BtnNav,
    "management-nav": managementBar,
    "side-menu": managementMenu,
    datetime: Datetime,
    heading: Title,
    popup: Popup,
    check: PrettyCheck,
  },
  data() {
    return {
      showPopup: false,
      init_edit: false,
      sessions: [],
      speakers: [],
      venues: [],
      selectedPanelists: [],
      speakers_obj: {},
      session: {
        title: null,
        start_date: null,
        start_time: null,
        end_time: null,
        venue_name: null,
        area: null,
        location: null,
        description: null,
        tags: [],
        exhibitors: [],
        panelists: [],
        is_session: false,
        hide_on_agenda: false,
      },
      event: {},
      start_date: null,
      selectedVenue: null,
      selectedArea: null,
    };
  },
  firestore() {
    return {
      event: db.collection("event").doc(this.$route.params.id),
      sessions: db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("sessions")
        .orderBy("start_time", "asc"),
      speakers: db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("panelists"),
      venues: db
        .collection("user")
        .doc(auth.currentUser.uid)
        .collection("venues"),
    };
  },
  computed: {
    start_time: {
      get() {
        return this.session.start_time
          ? moment(this.session.start_time).format("hh:mm a")
          : null;
      },
      set(timestring) {
        this.session.start_time = new Date(timestring).valueOf();
      },
    },
    end_time: {
      get() {
        return this.session.end_time
          ? moment(this.session.end_time).format("hh:mm a")
          : null;
      },
      set(timestring) {
        this.session.end_time = new Date(timestring).valueOf();
      },
    },
    eventDates() {
      var getDaysArray = function (start, end) {
        for (
          var arr = [], dt = new Date(start);
          dt <= end;
          dt.setDate(dt.getDate() + 1)
        ) {
          let date = Object.assign({
            label: moment(new Date(dt)).format("MMMM Do YYYY"),
            timestamp: dt.getTime(),
          });
          arr.push(date);
        }
        return arr;
      };
      let start = this.event.start_time;
      let end = this.event.end_time;
      return getDaysArray(start, end);
    },
  },
  watch: {
    speakers: {
      deep: true,
      handler() {
        this.speakers.forEach((s) => {
          this.speakers_obj[s.id] = Object.assign({ id: s.id }, s);
        });
      },
    },
    selectedPanelists: {
      deep: true,
      handler() {
        this.session.panelists = this.selectedPanelists.map(
          (id) => this.speakers_obj[id]
        );
      },
    },
    start_date(val) {
      if (!isNaN(val)) {
        this.session.start_date = val;
      }
    },
    selectedArea(val) {
      let venue = Object.assign({}, this.selectedVenue);
      delete venue.areas;
      venue.area = val;
      this.session.venue = venue;
    },
  },
  methods: {
    validation() {
      let valid = true;
      let session = this.session;
      valid = Boolean(
        session.title &&
          session.start_time &&
          session.end_time &&
          session.description &&
          session.panelists.length
      );

      if (valid) {
        this.addAgenda();
      } else {
        return Swal.fire("", "Please fill in all required fields (*)", "info");
      }
    },
    openPopup() {
      this.showPopup = true;
    },
    addTags(e) {
      let tag = e.target.value;
      this.session.tags.push(tag);
      this.$refs.tags.value = null;
    },
    removeTag(i) {
      this.session.tags.splice(i, 1);
    },
    closePopup() {
      this.showPopup = false;
      this.init_edit = false;
      this.selectedPanelists = [];
      this.selectedVenue = null;
      this.selectedArea = null;
      this.start_date = null;
      this.session = {
        title: null,
        start_date: null,
        start_time: null,
        end_time: null,
        venue_name: null,
        area: null,
        location: null,
        description: null,
        tags: [],
        exhibitors: [],
        panelists: [],
        is_session: false,
        hide_on_agenda: false,
      };
    },
    addAgenda() {
      let agenda = this.session;
      let agendaRef = !this.init_edit
        ? db
            .collection("event")
            .doc(this.$route.params.id)
            .collection("sessions")
            .doc()
        : db
            .collection("event")
            .doc(this.$route.params.id)
            .collection("sessions")
            .doc(agenda.id);

      agenda.start_time = new Date(agenda.start_time).getTime();
      agenda.end_time = new Date(agenda.end_time).getTime();
      agenda.location = `${this.event.address.address_1} ${this.event.address.city} ${this.event.address.state} ${this.event.address.zip}`;

      agendaRef
        .set(agenda, { merge: true })
        .then(() => {
          this.closePopup();
        })
        .catch((err) => console.log(err));
    },
    deleteAgenda(id) {
      return Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to undo this",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "DELETE",
        cancelButtonText: "CANCEL",
      }).then((result) => {
        if (result.value) {
          return db
            .collection("event")
            .doc(this.$route.params.id)
            .collection("sessions")
            .doc(id)
            .delete();
        }
      });
    },
    editAgenda(item) {
      item.start_time = new Date(item.start_time).toISOString();
      item.end_time = new Date(item.end_time).toISOString();

      this.session = JSON.parse(Object.assign(JSON.stringify(item)));
      this.session.id = item.id;
      this.selectedPanelists = this.session.panelists.map((s) => s.id);
      this.start_date = moment(item.start_date).format("MMMM Do YYYY");
      this.selectedVenue = item.venue;
      this.selectedArea = item.venue.area;
      this.showPopup = true;
      this.init_edit = true;
    },
    formatArray(item, key, subkey) {
      let formattedArr = item[key]
        ? item[key].map((e) => e[subkey]).join(" ")
        : "TBD";
      return formattedArr;
    },
  },
};
</script>

<style lang="scss">
.agendas {
  margin-top: 30px;
  .agenda {
    position: relative;
    .date {
      background: #efefef;
      padding: 15px 20px;

      p {
        margin: 0;
      }
    }

    .datetime {
      width: 200px;
      margin-right: 50px;
      flex: none;
      .input {
        width: 100%;
      }
    }

    .agenda_inputs {
      width: 100%;
      margin-right: 50px;
      max-width: 400px;

      .input {
        width: 100%;
        margin-bottom: 15px;

        textarea {
          resize: none;
        }
      }
    }

    .description {
      p {
        width: 200px;
        word-wrap: break-word;
      }
    }

    .settings {
      // display: flex;
      // position: absolute;
      // right: 20px;
      // top: 20px;
      img {
        height: 23px;
        cursor: pointer;
        &:first-of-type {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
